export default __webpack_public_path__ + "static/media/0xbc91347e80886453f3f8bbd6d7ac07c122d87735.6766223a.webp";